import React, { useEffect, useState } from 'react';
import {
  Button,
  Icon,
  useTranslation,
  ConfirmationModal,
} from '@testsigma/atoms';
import {
  MetadataConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';
import error from '@images/error.svg';
import classNames from 'classnames';

export const MetadataConnectionDuplication: React.FC = () => {
  const { handleUpdateMetadataConnectionModalScreen, duplicateConnectionName } = useSFConnectionState();

  const { t } = useTranslation();

  const handleGoBack = () => {
    handleUpdateMetadataConnectionModalScreen(
      MetadataConnectionModalScreens.CONNECTION_CREATE_SCREEN,
    );
  };

  return (
    <>
      <div className='items-center h-[292px]'>
        <div className='flex w-12 h-12 bg-red-100 rounded-full ml-5 mt-5'>
          {<img src={error} alt='' />}
        </div>

        <div className='w-full mt-5 ml-3 px-7 py-4'>
          <h3
            role='heading'
            className='text-xl pb-4 font-semibold'
          >
            {t('duplicate_connection_details')}
          </h3>

          <div className='text-unique-800 font-normal text-small flex flex-wrap'>
          <div
            className="leading-relaxed"
            dangerouslySetInnerHTML={{
              __html: t('duplicate_connection_message', {
                connectionName: duplicateConnectionName || 'your connection',
              }),
            }}
          />
          </div>


          <Button type='secondary' className='mt-6 ml-1' onClick={handleGoBack}>
          {t('salesforce_connections_go_back')}
          </Button>
        </div>
      </div>
    </>
  );
};
